/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeRosterReassignShiftsCtrl
 */
angular.module('mercury.modules.time.roster')
  .controller('TimeRosterReassignShiftsCtrl', ["$q", "dialog", "$state", "$scope", "Rosters", "staffMember", function ($q, dialog, $state, $scope, Rosters, staffMember) {
    var filteredStaff = [];
    angular.forEach($scope.staff, function (member) {
      if (member.datestampDeleted === null && member.showInRoster) {
        filteredStaff.push(member);
      }
    });

    $scope.staff = filteredStaff;
    $scope.member = staffMember;

    /**
     * Evaluates whether the reassign button should be disabled or not.
     * @returns true if the elements in dialog are valid, false if not
     */
    $scope.disableReassign = function () {
      return $scope.selectedStaffMemberId == null;
    };

    $scope.reassignShifts = function (staffMemberIdFrom) {

      $scope.reassigningShifts = $scope.$parent.isTemplate ?
        Rosters.reassignTemplateShifts(
          $scope.templateId,
          staffMemberIdFrom,
          $scope.selectedStaffMemberId
        ) :
        Rosters.reassignShifts(
          $scope.viewStartDateTime,
          $scope.viewEndDateTime,
          staffMemberIdFrom,
          $scope.selectedStaffMemberId
        ) ;

      $scope.reassigningShifts
        .then(function () {
          $state.reload();
          dialog.close();
        });

    };

    $scope.updateSelectedStaffMember = function (staffMember) {
      $scope.selectedStaffMemberId = staffMember ? staffMember.id : null;
    };

    $scope.selectStaffMemberMore = function (staffMemberIdFrom) {
      dialog.open({
        controller: 'StaffPopupCtrl',
        templateUrl: 'modules/time/staff/popuplist.tpl.html',
        scope: $scope
      }).then(function (result) {
        $scope.selectedStaffMemberId = result.id;
        $scope.reassignShifts(staffMemberIdFrom);
        dialog.close();
      });
    };
  }]);
